import React from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { Grid } from "@material-ui/core";
import { Input, InputTags } from "../../../components/inputs/newForm";
import Styles from "../styles/Styles";
import { masks } from "../../../utils";

const filtersSchema = z.object({
  fullName: z.string().optional(),
  email: z.string().optional(),
  placeIds: z.any().optional(),
  cpf: z.string().optional(),
});
type FiltersFormData = z.infer<typeof filtersSchema>;

function Filters({ onSubmit, loading, placeList }) {
  const { control, handleSubmit, reset } = useForm<FiltersFormData>({
    resolver: zodResolver(filtersSchema),
    defaultValues: { fullName: "", email: "", placeIds: [], cpf: "" },
  });

  return (
    <form style={{ display: "flex", width: "100%", flexDirection: "column" }}>
      <Grid container spacing={1}>
        <Grid item xs={12} md={6} lg={3}>
          <Input control={control} name="fullName" label="Nome Completo" />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <Input control={control} name="email" label="E-mail" />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <InputTags
            control={control}
            name="placeIds"
            label="Imóvel"
            options={placeList ? placeList : []}
            multiple
          />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <Input control={control} name="cpf" label="CPF" />
        </Grid>
      </Grid>
      <Styles.ButtonContainer>
        <Styles.Clear
          loading={loading}
          disabled={loading}
          fullWidth={false}
          onClick={() => reset()}
        >
          Limpar
        </Styles.Clear>
        <Styles.Submit
          loading={loading}
          disabled={loading}
          fullWidth={false}
          onClick={handleSubmit((data) =>
            onSubmit({ ...data, cpf: masks.removeNumberMask(data.cpf ?? "") })
          )}
          style={{ borderRadius: 28 }}
        >
          Aplicar Filtros
        </Styles.Submit>
      </Styles.ButtonContainer>
    </form>
  );
}

export default Filters;
